/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/ContentMenuAPI'
], (APIFactory, ContentMenuAPI) => {

	class ContentMenu {

		constructor() {
			this.api = APIFactory.createAPI(this, [ContentMenuAPI]);
			this.providers = {};
		}

		registerProvider(name, provider) {
			this.providers[name] = provider;
		}

		getContentMenuList(idList) {
			const contentMenuList = [];
			Object.values(this.providers).forEach(provider => {
				if (provider.getContentMenuList && typeof(provider.getContentMenuList) === 'function'){
					let actions = null;
					try {
						actions = provider.getContentMenuList(idList);
					} catch(e) {
						console.log(e);
					}
					if(actions) {
						contentMenuList.push(...actions);
					}
				}
			});
			return contentMenuList;
		}

		getAPI(){
			return this.api;
		}
	}

	return ContentMenu;
});
